var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "c-icon",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 157.61 157.61"
      }
    },
    [
      _c("line", {
        staticClass: "c-icon__line",
        attrs: { x1: "152.61", y1: "5", x2: "5", y2: "152.61" }
      }),
      _vm._v(" "),
      _c("line", {
        staticClass: "c-icon__line",
        attrs: { x1: "5", y1: "5", x2: "152.61", y2: "152.61" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }